import { ExtendedNotificationType } from "@/stores/notifications/notificationStore";
import NotificationsActionContainer from "@/domains/notifications/containers/NotificationsActionContainer";
import NotificationsOfferContainer from "@/domains/notifications/containers/NotificationsOfferContainer";
import NotificationTransactionContainer from "@/domains/notifications/containers/NotificationsTransactionContainer";

export const notificationsComponents = {
  [ExtendedNotificationType.Action]: {
    size: 1,
    component: NotificationsActionContainer,
  },
  [ExtendedNotificationType.Offer]: {
    size: 2,
    component: NotificationsOfferContainer,
  },
  [ExtendedNotificationType.Transaction]: {
    size: 1.5,
    component: NotificationTransactionContainer,
  },
};
